// extracted by mini-css-extract-plugin
export default {"hero":"About_hero__MG+NZ","hero_col":"About_hero_col__+t+KY"};